import { useMemo } from 'react';
import {
  Cell,
  ReferenceLine,
  ResponsiveContainer,
  Scatter,
  ScatterChart,
  Tooltip,
  XAxis,
  YAxis,
  ZAxis,
} from 'recharts';
import type { ClusterOutlierPoint } from '@avisoma/shared';
import { clusterColor, THRESHOLD_LINE_COLOR } from './clusterColor';
import { ClusterTooltip } from './ClusterTooltip';

export function ClusterOutlierStrip({
  points,
  threshold,
  hoveredId,
  onHover,
  onSelect,
}: {
  points: ClusterOutlierPoint[];
  threshold: number | null;
  hoveredId: number | null;
  onHover: (id: number | null) => void;
  onSelect: (id: number) => void;
}) {
  const data = useMemo(() => points.map((point) => ({ ...point, row: 1 })), [points]);

  return (
    <div className="h-[150px] w-full">
      <ResponsiveContainer width="100%" height="100%">
        <ScatterChart accessibilityLayer={false} margin={{ top: 10, right: 20, left: 10, bottom: 20 }}>
          <XAxis
            type="number"
            dataKey="distance"
            domain={[0, 'auto']}
            tick={{ fontSize: 11 }}
            label={{ value: 'Distance from category mass', position: 'insideBottom', offset: -12, fontSize: 12 }}
          />
          <YAxis type="number" dataKey="row" domain={[0, 2]} hide />
          <ZAxis type="number" dataKey="pageCount" range={[40, 400]} />
          {threshold !== null && (
            <ReferenceLine x={threshold} stroke={THRESHOLD_LINE_COLOR} strokeDasharray="5 4" />
          )}
          <Tooltip content={<ClusterTooltip />} />
          <Scatter data={data} cursor="pointer" onMouseLeave={() => onHover(null)}>
            {data.map((point) => (
              <Cell
                key={point.id}
                fill={clusterColor(point, threshold)}
                fillOpacity={hoveredId === null || hoveredId === point.id ? 0.7 : 0.15}
                onMouseEnter={() => onHover(point.id)}
                onClick={() => onSelect(point.id)}
              />
            ))}
          </Scatter>
        </ScatterChart>
      </ResponsiveContainer>
    </div>
  );
}
